



import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { upcomingEvents, pastEvents, featuredEvents } from './webinarData';
import axios from 'axios';
import information from '../../../../Assets/webinar/information.png'
import whyAttend from '../../../../Assets/webinar/question-mark.png'
import WhoAttend from '../../../../Assets/webinar/profile.png'

const ICONS = {
  calendar: (
    <svg className="w-5 h-5 mr-2" fill="#3B82F6" viewBox="0 0 20 20">
      <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
    </svg>
  ),
  clock: (
    <svg className="w-5 h-5 mr-2" fill="#A21CAF" viewBox="0 0 20 20">
      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
    </svg>
  ),
  location: (
    <svg className="w-5 h-5 mr-2" fill="#F59E42" viewBox="0 0 20 20">
      <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
    </svg>
  ),
  info: (
    <svg className="w-6 h-6 text-[#F59E42]" fill="none" stroke="#F59E42" strokeWidth="2" viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="10" stroke="#F59E42" strokeWidth="2" fill="none"/>
      <path d="M12 16v-4M12 8h.01" stroke="#F59E42" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  check: (
    <svg className="w-5 h-5 mt-1" fill="#10B981" viewBox="0 0 20 20">
      <circle cx="10" cy="10" r="10" />
      <path d="M7 10l2 2 4-4" stroke="#fff" strokeWidth="2" fill="none" />
    </svg>
  ),
  users: (
    <svg className="w-6 h-6 text-[#3B82F6]" fill="none" stroke="#3B82F6" strokeWidth="2" viewBox="0 0 24 24">
      <path d="M17 20h5v-2a4 4 0 00-3-3.87M9 20H4v-2a4 4 0 013-3.87M16 7a4 4 0 11-8 0 4 4 0 018 0zm6 13v-2a4 4 0 00-3-3.87M6 7a4 4 0 118 0" />
    </svg>
  ),
};

const EventDetail = () => {
  const { id } = useParams();
  const [event, setEvent] = useState(null);
  const [eventType, setEventType] = useState('');
  const [showRegistrationModal, setShowRegistrationModal] = useState(false);
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    phone: '',
  });
  const [modalFormData, setModalFormData] = useState({
    name: '',
    email: '',
  });

  useEffect(() => {
    const findEvent = () => {
      let foundEvent;
      let type = '';
      foundEvent = upcomingEvents.find(e => e.id === id);
      if (foundEvent) {
        type = 'upcoming';
      } else {
        foundEvent = pastEvents.find(e => e.id === id);
        if (foundEvent) {
          type = 'past';
        } else {
          foundEvent = featuredEvents.find(e => e.id === id);
          if (foundEvent) {
            type = 'featured';
          }
        }
      }
      setEvent(foundEvent);
      setEventType(type);
    };
    findEvent();
  }, [id]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleModalInputChange = (e) => {
    const { name, value } = e.target;
    setModalFormData({ ...modalFormData, [name]: value });
  };
const obj= {
    "mainHeadline":"Manufacturing Smarter - Streamline Operations & Accelerate Growth",
    "eventDate":"June 18, 2025"
  }
  const handleRegistrationSubmit = async (e) => {
    e.preventDefault();
    const registrationData = {
      ...formData,
      event: obj
    };
    try {
      toast.info('Please wait we are sending your details...', {
        position: "top-center",
        autoClose: 3000,
      });
      const response = await axios.post('https://api.kapiltech.com/api/ptkcs/registration', registrationData);
      if (response.data.success) {
        toast.success('Thank you for registration! Please check your registered email for the event link.', {
          position: "top-center",
          autoClose: 5000,
        });
        setFormData({
          name: '',
          email: '',
          company: '',
          phone: '',
        });
      } else {
        toast.error(response.data.message || 'Registration failed. Please try again later.');
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Registration failed. Please try again later.';
      toast.error(errorMessage);
      console.error('Registration error:', error);
    }
  };

  

  const handleModalRegistrationSubmit = async (e) => {
    e.preventDefault();
    try {
      const submissionData = {
        ...modalFormData,
        event: event
      };
      const response = await axios.post('https://api.kapiltech.com/api/webinar/watchnow', submissionData);
      toast.success('Thank you for your interest! The video will start shortly.', {
        position: "top-center",
        autoClose: 3000,
      });
      setModalFormData({
        name: '',
        email: '',
      });
      setShowRegistrationModal(false);
      setTimeout(() => {
        setShowVideoModal(true);
      }, 1000);
    } catch (error) {
      console.error('Registration error:', error);
      toast.error(error.response?.data?.message || 'Registration failed. Please try again later.');
    }
  };

  const handleWatchNowClick = () => {
    setShowRegistrationModal(true);
  };

  if (!event) {
    return (
      <div className="flex items-center justify-center h-screen bg-gradient-to-br from-[#e0e7ff] to-[#f3e8ff]">
        <div
          className="w-16 h-16 border-t-4 rounded-full animate-spin"
          style={{ borderColor: "#3B82F6" }}
        />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#e0e7ff] via-[#fff] to-[#f3e8ff]">
      <ToastContainer />
      {/* Hero Section */}
      <div className="relative h-96 overflow-hidden">
        <div
          className="absolute inset-0"
          style={{
            backgroundColor: "#0f172a",
            backgroundImage: "url('/images/event-bg-pattern.svg')",
            backgroundSize: "cover"
          }}
        >
          <div className="absolute inset-0" style={{ background: "linear-gradient(90deg, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0) 100%)" }} />
        </div>
        <div className="container mx-auto px-6 pt-32 pb-16 relative z-10 h-full flex flex-col justify-center">
          <span className="font-semibold uppercase tracking-wider block mb-2" style={{ color: "#10B981" }}>
            {eventType === 'upcoming' ? 'Upcoming Event' :
              eventType === 'past' ? 'Past Event' : 'Featured Event'}
          </span>
          <h1 className="text-lg sm:text-lg md:text-xl lg:text-3xl font-semibold text-white mb-2 breaks-words">{event.mainHeadline}</h1>
          <p className="text-md  sm:text-md md:text-md mb-6" style={{ color: "#F1F5F9" }}>{event.subHeadline}</p>
          <div className="flex flex-wrap gap-4 mt-8">
            <div className="flex items-center text-white">{ICONS.calendar}{event.eventDate}</div>
            <div className="flex items-center text-white">{ICONS.clock}{event.time}</div>
            <div className="flex items-center text-white">{ICONS.location}{event.location}</div>
          </div>
        </div>
      </div>

      {/* Event Details Section */}
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
          {/* Left Column - Event Details */}
          <div className="lg:col-span-2  rounded-lg bg-white">
            <div className=" p-8 mb-8" style={{ backgroundColor: "#fff" }}>
              <h2 className="text-2xl font-bold mb-4" style={{ color: "#1e293b" }}>About This Event</h2>
              <div className="flex items-start gap-3 mb-6">
                <img src={information} alt="kcs-Tech Webinar Information" className="w-8 h-8 object-contain" />
                <p className="text-[#334155]">{event.briefDescription}</p>
              </div>
              <div className="mb-8">
                <h3 className="text-xl font-semibold mb-3 flex items-center gap-2" style={{ color: "#1e293b" }}>
                  <img src={whyAttend} alt="" className='h-8 w-8 object-contain' />
                  Why Attend?
                </h3>
                <ul className="space-y-2">
                  {event.whyAttend.map((item, idx) => (
                    <li key={idx} className="flex items-start gap-2">
                      {ICONS.check}
                      <span className="text-[#334155]">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div>
                <h3 className="text-xl font-semibold mb-3 flex items-center gap-2" style={{ color: "#1e293b" }}>
                  <img src={WhoAttend} alt="KCS-Tech MES webinar, WHO Should Attend" className='h-8 w-8 object-contain' />
                  {event.WhoShouldAttend.title}
                </h3>
                <p className="mb-2 text-[#334155]">{event.WhoShouldAttend.description}</p>
                <div className="flex flex-wrap gap-2">
                  {event.WhoShouldAttend.audience.map((aud, idx) => (
                    <span
                      key={idx}
                      className="bg-[#e0e7ff] text-[#3730a3] px-3 py-1 rounded-full text-xs font-medium"
                    >
                      {aud}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Right Column - Registration */}
          <div className="lg:col-span-1">
            <div className="rounded-xl shadow-xl p-6 sticky top-6" style={{ backgroundColor: "#fff" }}>
              {eventType === 'upcoming' ? (
                <>
                  <h2 className="text-2xl font-bold mb-6" style={{ color: "#1e293b" }}>Register for This Event</h2>
                  <div className="mb-6 p-4 rounded-lg border" style={{ backgroundColor: "#f3e8ff", borderColor: "#a5b4fc" }}>
                    <div className="flex items-center justify-between">
                      <span style={{ color: "#374151" }}>Event Date:</span>
                      <span className="font-semibold" style={{ color: "#062557" }}>{event.eventDate}</span>
                    </div>
                  </div>
                  <form onSubmit={handleRegistrationSubmit}>
                    <div className="mb-4">
                      <label className="block font-medium mb-2" style={{ color: "#374151" }} htmlFor="name">Full Name<span className="ml-1 text-lg" style={{ color: "#ef4444" }}>*</span> </label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:border-transparent"
                        style={{ borderColor: "#d1d5db", outlineColor: "#3B82F6" }}
                        placeholder="Your full name"
                        required
                        value={formData.name}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className="mb-4">
                      <label className="block font-medium mb-2" style={{ color: "#374151" }} htmlFor="email">Email Address  <span className="ml-1 text-lg" style={{ color: "#ef4444" }}>*</span>   </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:border-transparent"
                        style={{ borderColor: "#d1d5db", outlineColor: "#3B82F6" }}
                        placeholder="your.email@example.com"
                        required
                        value={formData.email}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className="mb-4">
                      <label className="block font-medium mb-2" style={{ color: "#374151" }} htmlFor="company">Organization <span className="ml-1 text-lg" style={{ color: "#ef4444" }}>*</span></label>
                      <input
                        type="text"
                        id="company"
                        name="company"
                        className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:border-transparent"
                        style={{ borderColor: "#d1d5db", outlineColor: "#3B82F6" }}
                        placeholder="Your company or organization"
                        value={formData.company}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className="mb-6">
                      <label className="block font-medium mb-2" style={{ color: "#374151" }} htmlFor="phone">Phone Number <span className="ml-2 px-2 py-1 text-xs rounded-full" style={{ backgroundColor: "#f1f5f9", color: "#64748b" }}>Optional</span></label>
                      <input
                        type="number"
                        id="phone"
                        name="phone"
                        className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:border-transparent"
                        style={{ borderColor: "#d1d5db", outlineColor: "#3B82F6" }}
                        placeholder="Your phone number"
                        value={formData.phone}
                        onChange={handleInputChange}
                      />
                    </div>
                    <button
                      type="submit"
                      className="w-full py-3 px-6 text-white font-medium rounded-lg shadow-lg transition-all"
                      style={{ background: "linear-gradient(90deg, #10B981 0%, #3B82F6 100%)" }}
                    >
                      Register Now
                    </button>
                  </form>
                </>
              ) : (
                <>
                  <div className="text-center mb-6">
                    <div className="inline-block p-3 mb-4 rounded-full" style={{ backgroundColor: "#f3e8ff" }}>
                      <svg className="w-8 h-8" style={{ color: "#A21CAF" }} fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                      </svg>
                    </div>
                    <h2 className="text-2xl font-bold mb-2" style={{ color: "#1e293b" }}>
                      {eventType === 'past' ? 'Event Completed' : 'Featured Event'}
                    </h2>
                    <p className="mb-6" style={{ color: "#64748b" }}>
                      {eventType === 'past'
                        ? 'This event has already taken place. You can still watch the recording.'
                        : 'This is one of our featured events. Watch an exclusive preview.'}
                    </p>
                    <button
                      onClick={handleWatchNowClick}
                      className="w-full py-3 px-6 text-white font-medium rounded-lg shadow-lg transition-all"
                      style={{ background: "linear-gradient(90deg, #A21CAF 0%, #3B82F6 100%)" }}
                    >
                      Watch Now
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Registration Modal for Past/Featured Events */}
      {showRegistrationModal && (
        <div className="fixed inset-0 flex items-center justify-center z-50 p-4" style={{ backgroundColor: "rgba(0, 0, 0, 0.7)" }}>
          <div
            className="rounded-lg shadow-2xl max-w-md w-full p-6 bg-white"
          >
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-bold" style={{ color: "#1e293b" }}>Register to Watch</h3>
              <button
                onClick={() => setShowRegistrationModal(false)}
                className="hover:text-[#64748b] text-[#94a3b8]"
              >
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </button>
            </div>
            <form onSubmit={handleModalRegistrationSubmit}>
              <div className="mb-4">
                <label className="block font-medium mb-2" style={{ color: "#374151" }} htmlFor="modal-name">Full Name</label>
                <input
                  type="text"
                  id="modal-name"
                  name="name"
                  className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:border-transparent"
                  style={{ borderColor: "#d1d5db", outlineColor: "#3B82F6" }}
                  placeholder="Your full name"
                  required
                  value={modalFormData.name}
                  onChange={handleModalInputChange}
                />
              </div>
              <div className="mb-4">
                <label className="block font-medium mb-2" style={{ color: "#374151" }} htmlFor="modal-email">Email Address</label>
                <input
                  type="email"
                  id="modal-email"
                  name="email"
                  className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:border-transparent"
                  style={{ borderColor: "#d1d5db", outlineColor: "#3B82F6" }}
                  placeholder="your.email@example.com"
                  required
                  value={modalFormData.email}
                  onChange={handleModalInputChange}
                />
              </div>
              <div className="flex justify-end mt-6">
                <button
                  type="button"
                  onClick={() => setShowRegistrationModal(false)}
                  className="px-4 py-2 mr-2 border rounded-lg hover:bg-[#f3f4f6]"
                  style={{ borderColor: "#d1d5db", color: "#374151" }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 rounded-lg text-white"
                  style={{ backgroundColor: "#3B82F6" }}
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Video Modal */}
      {showVideoModal && (
        <div className="fixed inset-0 flex items-center justify-center z-50 p-4" style={{ backgroundColor: "rgba(0, 0, 0, 0.8)" }}>
          <div
            className="rounded-lg shadow-2xl max-w-3xl w-full p-6 bg-white"
          >
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-bold" style={{ color: "#1e293b" }}>
                {eventType === 'past' ? 'Event Recording' : 'Event Preview'}
              </h3>
              <button
                onClick={() => setShowVideoModal(false)}
                className="hover:text-[#64748b] text-[#94a3b8]"
              >
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </button>
            </div>
            <div className="aspect-w-16 aspect-h-9">
              <iframe
                className="w-full h-96 rounded-lg"
                src="https://www.youtube.com/embed/dQw4w9WgXcQ"
                title="Event Video"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="mt-4 text-center">
              <p className="text-[#64748b]">Thank you for your interest in our event!</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EventDetail;